import React from 'react';

// import { Container } from './styles';

function Logout() {
  return (
    <iframe src="https://www.fitbit.com/logout" width="540" height="450" style={{display: 'none'}}></iframe>
  );
}

export default Logout;